module.exports = __webpack_public_path__ + "static/img/u-jelly-landing-pad_256.48b5600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/u-jelly-landing-pad_256.png
// module id = Mrwo
// module chunks = 0